
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lowCostSearch",
      function () {
        return require("private-next-pages/lowCostSearch.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lowCostSearch"])
      });
    }
  